/* eslint no-console: 0 */

//// Dashboard for cleaners used by cleaners
import Vue from 'vue'
import CleanerApplicationForm from '@/cleaners/application_form.vue'
import i18n from '@/shared/i18n'
import { getBrowserLocale } from '@/utils'
import VueResource from 'vue-resource/dist/vue-resource'
Vue.use(VueResource)
import Interceptors from '@/interceptors.js'

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    i18n,
    el: '#cleaner_registration',
    components: { CleanerApplicationForm },
    data() {
      return {}
    },
    created() {
      Vue.http.interceptors.push(Interceptors.csrf_and_disable_caching)
      this.$i18n.locale = getBrowserLocale()
    },
    mounted() {
    },
    computed: {
    },
    methods: {

    }
  });
  //// This is used inside validations.js to provide localized validation messages
  Window.$i18n = app.$i18n
})
